import { render, staticRenderFns } from "./VariantProductListingSection.vue?vue&type=template&id=3184f20c&scoped=true&"
import script from "./VariantProductListingSection.vue?vue&type=script&lang=js&"
export * from "./VariantProductListingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3184f20c",
  null
  
)

export default component.exports